import React, { createContext, useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { createPortal } from 'react-dom'
import { deserialize } from 'utils/react-serialize'
import * as components from 'components'

const resolveDomComponents = () =>
  Array.from(document.querySelectorAll('[data-react-component]')).map(element => ({
    element,
    component: deserialize(element.dataset.reactComponent, { components })
  }))

export const ReactContext = createContext({})
export const useReact = () => useContext(ReactContext)

export default function ReactProvider({ children, mountDomComponents, onLoad }) {
  const [domComponents] = useState(mountDomComponents ? resolveDomComponents() : [])
  const providerValue = {}

  useEffect(() => {
    onLoad && onLoad()
  }, [onLoad])

  return (
    <ReactContext.Provider value={providerValue}>
      {children}
      {domComponents.map(({ element, component }) => {
        element.innerHTML = ''
        return createPortal(component, element)
      })}
    </ReactContext.Provider>
  )
}

ReactProvider.propTypes = {
  children: PropTypes.node,
  mountDomComponents: PropTypes.bool,
  onLoad: PropTypes.func
}

ReactProvider.defaultProps = {
  mountDomComponents: true
}
